import controleAcessoMenu from './controleacesso/menu.js';
import { administracaoMenu } from './administracao/menu.js';
// import rdStationMenu from './rdstation/menu.js';
// import mineradorMenu from './minerador/menu.js';
import gestaoEmailMenu from './gestaoemails/menu.js';
import mapaParceirosMenu from './mapaparceiros/menu.js';
import pagamentosMenu from './pagamentos/menu.js';
import agenciaConceitoMenu from './agenciaconceito/menu.js';
import rmMenu from './rm/menu.js';
import checkins from './checkins/menu.js';
import { crmMenu } from './crm/menu.js';
import { brasilMaisMenu } from './brasilmais/menu.js';
import solMenu from './sol/menu';
// import utilidadesMenu from './utilidades/menu.js';
import senacMenu from './senac/menu.js';
// import { nanMenu } from './nan/menu.js';
import menuVendas from './vendas/menu.js';
import { menuAutorizadorFinanceiro } from './autorizadoresFinanceiros/menu.js';
import integrapeMenu from './integrape/menu.js';
import solicitacoesMenu from './solicitacoes/menu.js';

const menu = [
    // rdStationMenu,
    // mineradorMenu,
    controleAcessoMenu,
    administracaoMenu,
    gestaoEmailMenu,
    pagamentosMenu,
    mapaParceirosMenu,
    agenciaConceitoMenu,
    rmMenu,
    crmMenu,
    checkins,
    brasilMaisMenu,
    // utilidadesMenu,
    senacMenu,
    solMenu,
    // nanMenu,
    menuVendas,
    menuAutorizadorFinanceiro,
    integrapeMenu,
    solicitacoesMenu,
];

export default menu;
